import RingCentralLogo from '@/assets/images/ring-central.svg';

const RingCentralIcon = ({ size = 25 }) => (
    <img
        src={RingCentralLogo}
        alt="Ring Central Logo"
        style={{ height: size, width: size }}
    />
);

export default RingCentralIcon;
